export default class Backend {
  // 1) es para despliegue
  // 2) la segunda y la tercera es para trabajar local

  // For deploy
  static backEndUrl = process.env.REACT_APP_API_URL;

  //For development
  //static backEndUrl = "http://localhost:3000/";
  //static backEndUrl = "http://168.176.26.91:8002/uapapp/";

  static openLink(url) {
    window.open(this.backEndUrl + url, "_blank");
  }

  static clearLocalStorage() {
    localStorage.removeItem("username");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("type");
    window.location.reload();
  }

  static async refreshToken() {
    return await this._request(
      "POST",
      "token/refresh",
      {
        "Content-Type": "application/json",
      },
      {
        refresh: localStorage.getItem("refresh"),
      }
    );
  }

  static _request(method, path, headers, body) {
    let newurl = this.backEndUrl + path;
    let answer = fetch(newurl, {
      method: method,
      headers: headers,
      body: JSON.stringify(body),
    });
    return answer;
  }

  static async sendRequest(method, path, body) {
    let request = await this._request(
      method,
      path,
      {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access"),
      },
      body
    );

    if (request.status === 401) {
      let refresh = await this.refreshToken();
      let res = await refresh.json();
      if (refresh.status === 401) {
        this.clearLocalStorage();
      }
      let newtoken = res["access"];
      localStorage.setItem("access", newtoken);
      let updatedRequest = await this._request(
        method,
        path,
        {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + newtoken,
        },
        body
      );
      return updatedRequest;
    } else {
      return request;
    }
  }

}


